import FunctionButton = OldUIContext.FunctionButton

import { servicesAPI } from "./api"
import { parseServicesCallbackWithValue } from "./api/services"

declare let window: OldUIContext.TenForceWindow

export const getScriptInformation = (
    action: string,
    conceptId?: number,
    itemId?: number,
): Promise<Api.ScriptingInformationResponse> => {
    const payload = {
        action: action ?? null,
        conceptId: conceptId ?? null,
        itemId: itemId ?? null,
    }
    return servicesAPI.postJSON(
        "GetCustomScriptInformation",
        payload,
        parseServicesCallbackWithValue<Api.ScriptingInformationResponse>,
    )
}

export interface ScriptOptions {
    openResult?: boolean
    openInNewWindows?: boolean
}

export interface ExecuteScriptOptions {
    itemId?: number | null
    listId?: number | null
    selectionId?: number | null
    scriptId?: number | null
    hasParams?: boolean
    parameters?: unknown[] | null
    handler?: FunctionButton | null
    options?: ScriptOptions
    cFieldId?: number | null
    listScriptId?: number | null
}

export const executeScript = ({
    cFieldId = null,
    handler = null,
    hasParams = false,
    itemId = null,
    listId = null,
    listScriptId = null,
    options = {},
    parameters = null,
    scriptId = null,
    selectionId = null,
}: ExecuteScriptOptions): Promise<void> =>
    window.scripting.executeItemScript(
        itemId,
        listId,
        selectionId,
        scriptId,
        hasParams,
        parameters,
        handler,
        options,
        cFieldId,
        listScriptId,
    )
